<script lang="ts" setup>
import { getFahrzeugColor } from "@/features/disposition/utils/colors";
import { ArrowRightIcon } from "@heroicons/vue/20/solid";
import { IAuftrag } from "@/features/abrechnung/api/useAbrechnungsplan";
import AuftragBegleitfahrt from "./AuftragBegleitfahrt.vue";
import FahrerAbgerechnetListe from "./FahrerAbgerechnetListe.vue";
import { formatDate, getWeekNumber } from "@/utils/date";

defineProps<{ auftrag: IAuftrag; query: () => void; noLink?: boolean }>();
</script>

<template>
  <div class="relative whitespace-normal group">
    <div class="block w-full px-4 py-2 bg-white shadow-md print:shadow-none">
      <div class="flex items-center leading-tight">
        <div>
          <span class="block font-medium tracking-wide text-gray-800">
            {{ auftrag.abholung.name }}
          </span>
        </div>
        <div class="mx-3">
          <ArrowRightIcon class="w-5 h-5 text-gray-800" />
        </div>
        <div>
          <span class="block font-medium tracking-wide text-gray-800">
            {{ auftrag.anlieferung.name }}
          </span>
        </div>
        <div class="self-end ml-auto text-xs divide-x">
          <span v-if="auftrag.abrechnungsnummer" class="pr-2">
            {{ auftrag.abrechnungsnummer }}
          </span>
          <span class="pl-2">
            {{ formatDate(auftrag.abholung.datum) }}
            (KW{{ getWeekNumber(auftrag.abholung.datum) }})
          </span>
        </div>
      </div>
      <div
        v-if="auftrag.fahrzeug.abzurechnende_fahrer.length"
        class="text-gray-800 border-t border-gray-200 mt-0.5 pt-0.5"
      >
        <p
          class="block max-w-full"
          :class="getFahrzeugColor(auftrag.fahrzeug.fahrzeugtyp)"
        >
          <FahrerAbgerechnetListe
            :fahrer="auftrag.fahrzeug.abzurechnende_fahrer"
            :auftrag="auftrag"
            :query="query"
          />
        </p>
      </div>
      <div
        v-if="auftrag.begleitfahrten.length"
        class="flex pt-1 mt-0.5 border-t border-gray-200 divide-gray-200"
      >
        <div
          v-for="(begleitfahrt, index) in auftrag.begleitfahrten"
          :key="index"
          class="flex"
        >
          <div v-if="index > 0" class="w-px h-auto mx-3 bg-gray-200"></div>
          <div
            class="flex items-center justify-between space-x-4 text-xs leading-tight"
            :style="{
              color: begleitfahrt.typ.schriftfarbe,
              backgroundColor: begleitfahrt.typ.hintergrundfarbe,
            }"
          >
            <AuftragBegleitfahrt
              :begleitfahrt="begleitfahrt"
              :auftrag-von-datum="auftrag.abholung.datum"
              :auftrag="auftrag"
              :query="query"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!noLink"
        class="flex justify-end pt-1 mt-0.5 border-t border-gray-200 divide-gray-200"
      >
        <router-link
          :to="{
            name: 'abrechnung-auftrag',
            params: { auftragId: auftrag.id },
          }"
          class="block text-sm"
        >
          -> Öffnen
        </router-link>
      </div>
    </div>
  </div>
</template>
